import { render } from "./CroquiAvaria.vue?vue&type=template&id=c95f92fe"
import script from "./CroquiAvaria.vue?vue&type=script&lang=js"
export * from "./CroquiAvaria.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__